import { itemAtomFamily } from 'atoms'
import { useRecoilCallback } from 'recoil'

export const useDeleteItems = () => {
  return useRecoilCallback(({ reset }) => (id) => {
    reset(itemAtomFamily(id))
  })
}

export default useDeleteItems
